// extracted by mini-css-extract-plugin
export default {"google_translate_element":"GoogleTranslateButton_google_translate_element__bq7Hz","borderBox":"GoogleTranslateButton_borderBox__Y5I5A","box":"GoogleTranslateButton_box__AH5A6"};